module.exports = __webpack_public_path__ + "media/components/assets/icons/rank/top5-0755a27714ae68241509da78635f6efa.svg";